var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditdraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.69266 3.01178L1.85141 10.8519C1.78253 10.9212 1.7329 11.0073 1.70741 11.1017L0.0199065 17.2892C-0.00620579 17.3848 -0.00655551 17.4857 0.0188928 17.5816C0.044341 17.6774 0.0946825 17.7649 0.164813 17.835C0.234944 17.9051 0.322372 17.9555 0.418231 17.9809C0.514091 18.0064 0.614975 18.006 0.710656 17.9799L6.89816 16.2924C6.9925 16.2669 7.07858 16.2173 7.14791 16.1484L14.988 8.30715L9.69266 3.01178Z",
    fill: "#7CB966"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5058 3.40333L14.5965 0.494077C14.2801 0.17772 13.8509 0 13.4035 0C12.956 0 12.5269 0.17772 12.2104 0.494077L10.8863 1.8182L16.1817 7.11358L17.5058 5.78945C17.8221 5.473 17.9999 5.04385 17.9999 4.59639C17.9999 4.14892 17.8221 3.71978 17.5058 3.40333V3.40333Z",
    fill: "#7CB966"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditdraft);
export default __webpack_public_path__ + "static/media/edit draft.b4b07843a052f969470d07831a308361.svg";
export { ForwardRef as ReactComponent };